interface ProfileFrameIconProps {
  className?: string
}

export function ProfileFrameIcon({ className }: ProfileFrameIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 112 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2 10) scale(0.8)">
        <path
          d="M60.4404 26.0841C47.8435 29.6796 40.5256 42.8437 44.1212 55.4406C47.6481 67.7971 60.1666 75.0393 72.887 71.8765C73.2579 71.7186 73.6426 71.6088 73.9448 71.5746C74.0409 71.5471 74.089 71.5334 74.1852 71.506C74.2332 71.4922 74.2332 71.4922 74.2813 71.4785C86.4662 67.5326 93.2758 54.7736 89.797 42.4034C86.2014 29.8065 73.0374 22.4885 60.4404 26.0841Z"
          fill="#383843"
        />
        <path
          d="M101.539 77.5296C85.5719 72.4156 63.6956 78.6597 52.7377 91.4589C47.7981 97.2885 46.0107 103.778 47.6986 109.692C49.3866 115.606 54.3167 120.126 61.5275 122.436C69.5487 125.034 79.0404 124.769 87.887 122.244C96.7337 119.719 104.935 114.934 110.377 108.493C115.268 102.677 117.069 96.2353 115.368 90.2734C113.632 84.3733 108.75 79.8391 101.539 77.5296Z"
          fill="#383843"
        />
      </g>
    </svg>
  )
}
